import { Vector3 } from "../types";

export type allObjectProps = {
  id: string;
  name: string;
  type: string;
  imageURL: string;
  imageAltText: string;
  position: Vector3;
  stateKeys: string[] | undefined;
  stateValues: string[] | undefined;
  controlsOptions: string[] | undefined;
  currentUserInput: any;
};

export enum objectType {
  invalid = -1,
  sceneObject = 0,
  interactableObject = 1,
  controllableObject = 2,
  customObject = 3,
  compositeInteractableObject = 4,
}

export interface text_subs {
  name: string;
  value: string;
}

export interface objectPropsResult {
  text_subs: text_subs[];
  id: string;
  type: objectType;
  name: string;
  alt: string;
  image: string;
  position: Vector3;
  stateKeys: string[] | undefined;
  stateValues: string[] | undefined;
}

class validator {
  private static instance: validator;

  private constructor() {
    //Intentionally blank
  }

  public static getInstance() {
    if (!this.instance) this.instance = new validator();
    return this.instance;
  }

  validateObjectProps(allProps: allObjectProps): objectPropsResult {
    const result: objectPropsResult = {
      id: allProps.id,
      type: objectType.invalid,
      name: "",
      alt: "",
      image: "",
      position: { x: 0, y: 0, z: 0 },
      stateKeys: undefined,
      stateValues: undefined,
      text_subs: [],
    };

    switch (allProps.type) {
      case "sceneObject":
        result.type = objectType.sceneObject;
        break;
      case "interactableObject":
        result.type = objectType.interactableObject;
        break;
      case "controllableObject":
        result.type = objectType.controllableObject;
        break;
      case "customObject":
        result.type = objectType.customObject;
        break;
      case "compositeInteractableObject":
        result.type = objectType.compositeInteractableObject;
        break;
      default:
        result.type = objectType.invalid;
        return result;
    }

    result.name = allProps.name;
    result.image = allProps.imageURL;
    result.alt = allProps.imageAltText;
    result.position = allProps.position;
    result.stateKeys = allProps.stateKeys;
    result.stateValues = allProps.stateValues;

    result.text_subs = [];

    if (allProps.currentUserInput)
      for (const key in allProps.currentUserInput) {
        if (key.includes("text_")) {
          const property_name = key.replace("text_", "");
          result.text_subs.push({
            name: property_name,
            value: allProps.currentUserInput[key],
          });
        }
      }

    return result;
  }
}

export default validator;
